import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

export default function SelectEvent() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const events = state?.events ?? [];

  const goToEvent = (id) => {
    sessionStorage.setItem('from_auto_login', '1');
    navigate(`/app/events/manage/${id}/overview`, { replace: true });
  };

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div style={{ width: "100%", maxWidth: 560, background: "#fff", borderRadius: 12, padding: "32px 32px 24px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
        <h3 style={{ margin: "0 0 8px", fontSize: 20, fontWeight: 700 }}>Select Event</h3>
        <p style={{ color: "#888", margin: "0 0 24px", fontSize: 14 }}>Multiple events found with the same name. Please select one to continue.</p>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {events.map((event) => (
            <div
              key={event.id}
              onClick={() => goToEvent(event.id)}
              style={{ border: "1px solid #e8e8e8", borderRadius: 10, padding: "16px 20px", cursor: "pointer", transition: "box-shadow 0.2s, border-color 0.2s" }}
              onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.10)"; e.currentTarget.style.borderColor = "#d0d0d0"; }}
              onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "none"; e.currentTarget.style.borderColor = "#e8e8e8"; }}
            >
              <div style={{ fontWeight: 600, fontSize: 15 }}>{event.event_title}</div>
              <div style={{ color: "#888", fontSize: 13, marginTop: 4 }}>
                {event.hastag} &bull; {new Date(event.start_date).toLocaleDateString()}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
